<template>
  <div class="target-detailed-meta">
    <div class="vx-row mt-6 mb-10">
      <div class="vx-col w-full">
        <span id="create-campaign-s3-platform-websites-button" class="mr-3 span-tag span-tag-active">
          {{ $t('Targeting') }} ({{ value.length }} {{ $t('Selected') }})
        </span>
      </div>
    </div>

    <div class="vx-row mt-6 mb-10">
      <div class="vx-col w-full">
        <div class="autocomplete">
          <input id="create-campaign-s3-platform-search-input" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" v-model="filterText" :placeholder="search_placeholder" class="autocomplete-input">
        </div>
      </div>
    </div>

    <div class="vx-row pt-3 h-64 overflow-y-scroll treeContainer mx-0">
      <div class="vx-col w-full">
        <tree :data="tree" :filter="filterText" :options="treeOptions" ref="tree" @node:unchecked="removeTargetFromTree" @node:checked="addTargetFromTree">
          <span class="tree-text" slot-scope="{ node }">
            <span class="inline-block align-middle mr-3">
              {{ node.text }}
            </span>
          </span>
        </tree>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    editing: {
      type: Boolean,
      default: false,
      required: false
    },
    adsetIndex: {
      type: Number,
      required: true
    },
    acceptanceStatus: {
      type: Boolean | null,
      required: true
    }
  },
  data () {
    return {
      filterText: '',
      search_placeholder: 'Search Detailed Targeting',
      tree: this.getTreeData(),
      treeOptions: {
        checkbox: true
      },
      targeting: []
    }
  },
  methods: {
    getTreeData () {
      const ExcludedTargetingIds = [19, 20, 21, 22, 127, 74, 75, 76, 77, 81, 82, 85, 438]
      const rowData = this.$store.getters['campaign/targetingLookups'].meta_detailed_targeting.filter(target => !ExcludedTargetingIds.includes(target.id))
      this.targeting = rowData.map(target => ({ ...target }))

      this.targeting.forEach(target => {
        if (this.value.includes(target.id)) {
          target.state = { checked: true }
          this.expandNestedParent(this.targeting, target)
        }
      })

      return this.buildDetailedTargeting(this.targeting)
    },
    buildDetailedTargeting (targeting, parentId = 0) {
      const detailedTargeting = []

      targeting.forEach(target => {
        target.text = target.name
        target.data = {
          'id' : target.id,
          'type' : target.type,
          'targeting_id' : target.targeting_id
        }

        if (target.parent_id === parentId) {
          const children = this.buildDetailedTargeting(targeting, target.id)
          if (children.length > 0) {
            target.children = children
          }

          detailedTargeting.push(target)
        }
      })

      return detailedTargeting
    },
    expandNestedParent (targeting, target) {
      if (target.parent_id === 0) {
        return
      }

      const parent = targeting.find(parent => parent.id === target.parent_id)
      if (parent) {
        parent.state = { expanded: true }
      }

      if (parent.parent_id === 0) {
        return
      }

      this.expandNestedParent(targeting, parent)
    },
    removeTargetFromTree (node) {

      if (node.data.targeting_id) {
        this.value.splice(this.value.indexOf(node.data.id), 1)
      }
    },
    addTargetFromTree (node) {

      if (node.data.state && node.data.state.disabled) {
        node.states = { ...node.states, ...node.data.state }
        node.uncheck()
        node.unselect()
      } else if (node.data.targeting_id) {
        this.value.push(node.data.id)
      }
    }
  }
}
</script>

<style lang="scss">
.target-detailed-meta {
  .tree-children {
    margin-left: 24px;
  }
}
</style>
